module.exports = __webpack_public_path__ + "Flag-332.ebdafdce53c37f42935713c621a1a921.svg";